<template lang="pug">
v-dialog(
  :value="value",
  @input="$emit('input', $event)",
  :max-width="maxWidth",
  :min-width="minWidth",
  :persistent="persistent",
  :scrollable="scrollable"
)
  v-card.dialog-card
    //- Cabeçalho azul padrão
    v-card-title.dialog-header.d-flex.align-center.justify-space-between.pa-0.ma-0.pl-4.py-0
      span.text-subtitle-2.font-weight-bold {{ titulo }}
      v-btn(v-if="mostrarFechar", icon, x-small, @click="fechar")
        v-icon(small) mdi-close
    v-divider

    v-card-text.dialog-body.pa-3
      slot

    v-divider
    v-card-actions.dialog-actions.py-3
      v-spacer
      slot(name="acoes")
        v-btn.btn-action.text-none(text, small, @click="fechar") {{ textoCancelar }}
        v-btn.btn-primario.text-none(
          v-if="mostrarConfirmar",
          color="primary",
          small,
          :loading="carregando",
          :disabled="confirmarDesabilitado || carregando",
          @click="$emit('confirmar')"
        ) {{ textoConfirmar }}
</template>

<script>
export default {
  name: "BaseDialog",

  props: {
    value: {
      type: Boolean,
      default: false
    },
    titulo: {
      type: String,
      default: ""
    },
    maxWidth: {
      type: [String, Number],
      default: 500
    },
    minWidth: {
      type: [String, Number],
      default: undefined
    },
    persistent: {
      type: Boolean,
      default: false
    },
    scrollable: {
      type: Boolean,
      default: false
    },
    // Dialogs persistentes normalmente só fecham pelos botões de ação.
    mostrarFechar: {
      type: Boolean,
      default: true
    },
    mostrarConfirmar: {
      type: Boolean,
      default: true
    },
    textoCancelar: {
      type: String,
      default: "Cancelar"
    },
    textoConfirmar: {
      type: String,
      default: "Confirmar"
    },
    confirmarDesabilitado: {
      type: Boolean,
      default: false
    },
    carregando: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    fechar() {
      this.$emit("input", false);
      this.$emit("fechar");
    }
  }
};
</script>

<style scoped>
/* Cabeçalho azul padrão dos dialogs */
.dialog-header {
  min-height: 48px;
  font-size: 13px;
  font-weight: 600;
  color: #666;
  background-color: #e3f2fd;
  line-height: 0.8;
}

.dialog-body {
  overflow-y: auto;
  scrollbar-width: thin;
}

.dialog-actions {
  gap: 8px;
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.dialog-actions > .v-btn.v-btn {
  margin-left: 0;
  margin-right: 0;
}

.btn-action {
  height: 30px !important;
  min-width: 96px !important;
  padding: 0 12px !important;
  font-size: 12px !important;
  letter-spacing: 0.01em !important;
  border: 1px solid #d0d7de !important;
  color: #57606a !important;
  background-color: #ffffff !important;
  font-weight: 500 !important;
  border-radius: 6px !important;
}

.btn-primario {
  height: 30px !important;
  min-width: 96px !important;
  padding: 0 12px !important;
  font-size: 12px !important;
  letter-spacing: 0.01em !important;
  font-weight: 500 !important;
  border-radius: 6px !important;
}

.text-none {
  text-transform: none !important;
}
</style>
